import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=f946c398&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default,MenuSubmenu: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/Submenu.vue').default})
